import script from "./ObjetivesRow.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjetivesRow.vue?vue&type=script&setup=true&lang=js"

import "./ObjetivesRow.vue?vue&type=style&index=0&id=1afb9cf6&lang=css"

const __exports__ = script;

export default __exports__